import { NextPageContext } from "next";
import Head from "next/head";

import { dehydrate } from "@tanstack/react-query";

import { ApiCatalog } from "@/api";
import RegistrationLayout from "@/base/RegistrationLayout/RegistrationLayout";
import LogInPage from "@/login/LogInPage";
import { fetchUser } from "@/users/v3";
import getQueryClient from "@/utils/getQueryClient";

const SignInPageRoute = () => (
  <>
    <Head>
      <title>Newsela | Sign In</title>
    </Head>
    <RegistrationLayout
      mainContents={<LogInPage />}
      disableBack
      disableSignOut
      isCard
    />
  </>
);

export async function getServerSideProps(ctx: NextPageContext) {
  const queryClient = getQueryClient();

  try {
    const user = await queryClient.fetchQuery({
      queryKey: [ApiCatalog.user.key, "me"],
      queryFn: async () => await fetchUser("me", { ctx }),
      retry: false,
    });

    if (user) {
      const next = ctx.query["next"] as string | undefined;

      return {
        redirect: {
          destination: next || "/",
          permanent: false,
        },
      };
    }
  } catch (error) {
    // No need to show an error, this means here is no user logged in, so it can
    // continue to the sign-in.
    console.error(error);
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export default SignInPageRoute;
